/*

##### Variant Change Event #####
document.addEventListener('variant:change', function (e) {
  console.log(e.detail.variant);
});

*/


document.addEventListener("DOMContentLoaded", function() {
  if(window.location.href?.includes('/collections/')){
    let menuButtonsData = document.querySelectorAll('.menu-drawer__menu-button');
    menuButtonsData.forEach(menuButton => {
      menuButton.addEventListener('click', function(event) {
        toggleMenuButtonCustom(event)
      });
    }); 
  }
});

function toggleMenuButtonCustom(event) {
  if(window.location.href?.includes('/collections/')){
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        const parent = event.target.parentElement;
        const secondaryMenu = event.target.nextElementSibling;
        if (parent.classList.contains('is-open')) {
          slideUp(secondaryMenu);
          parent.classList.remove('is-open');
        } else {
          slideDown(secondaryMenu);
          parent.classList.add('is-open');
        }
      }, 200); // Adjust the timeout as needed 
  }
}
/***** Draggable section Start *****/
customElements.define('draggable-section',class draggableSection extends HTMLElement {
  constructor() {
    super();
    this.sectionHeight = this.getBoundingClientRect().height;
    this.sectionWidth = this.getBoundingClientRect().width;
    this.querySelectorAll('.js-drag-element').forEach((element) => this.dragElement(element)); 
  }
  dragElement(elmnt){
    let data = elmnt.getClientRects()[0];
    // console.log(data)
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0,
      posBottom = 0,
      posRight = 0,
      posTop = data.y,
      clientWidth = elmnt.offsetWidth,
      sectionHeight = this.sectionHeight - elmnt.offsetHeight;
  
    let dragMouseDown = (e) => {
      e = e || window.event;
      e.preventDefault();
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }
  
    let elementDrag = (e) => {
      e = e || window.event;
      e.preventDefault();
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
  
      let tmp = elmnt.getClientRects()[0];
  
      posTop = tmp.y;
      
      if(pos1 < 0) posBottom = 0;
      if(pos2 < 0) posRight = 0;

      let top = elmnt.offsetTop - pos2,
          eleBottom = elmnt.offsetTop + elmnt.offsetHeight,
          left = elmnt.offsetLeft - pos1,
          right = clientWidth + tmp.x,
          windowWidth = window.outerWidth - clientWidth;

      if(eleBottom > this.sectionHeight && posBottom == 0 ){
        posBottom = (top > sectionHeight) ? sectionHeight :top;
      }
      if(posBottom != 0) top = posBottom;
      
      if(right > window.outerWidth && posRight == 0 ) posRight = (left > windowWidth) ? (windowWidth - 20) : left;
      if(posRight != 0) left = posRight;

      // console.log(top)
      elmnt.style.top = ((top > 0) ? top : 0) + "px";
      elmnt.style.left = ((left > 0) ? left : 0) + "px";
    }
  
    let closeDragElement = () => {
      document.onmouseup = null;
      document.onmousemove = null;
    }

    if (document.getElementById(elmnt.id + "header")) {
      document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
    } else {
      elmnt.onmousedown = dragMouseDown;
    }
  }
});
/***** Draggable section End *****/


/***** Rotating Images *****/
window.addEventListener('scroll', function () {
  var $body = document.querySelector('body');
  var bodyHeight = $body.offsetHeight;

  var rotatingImg1 = document.querySelectorAll('.rotating-img1');
  for (var i = 0; i < rotatingImg1.length; i++) {
    rotatingImg1[i].style.transform = 'rotate(' + (window.pageYOffset / bodyHeight * 360) + 'deg)';
  }

  var rotatingImg2 = document.querySelectorAll('.rotating-img2');
  for (var j = 0; j < rotatingImg2.length; j++) {
    rotatingImg2[j].style.transform = 'rotate(-' + (window.pageYOffset / bodyHeight * 360) + 'deg)';
  }

  var rotatingImg3 = document.querySelectorAll('.rotating-img3');
  for (var k = 0; k < rotatingImg3.length; k++) {
    rotatingImg3[k].style.transform = 'rotate(-' + (window.pageYOffset / bodyHeight * 360) + 'deg)';
  }
  
});

document.addEventListener("DOMContentLoaded", function() {
  var header = document.querySelector(".outer-header-wrapper");

  window.addEventListener("scroll", function() {
    var scroll = window.pageYOffset || document.documentElement.scrollTop;
    if (scroll >= 20) {
        header.classList.add("scrolled");
    } else {
        header.classList.remove("scrolled");
    }
  });
});

/***** PDP Popups *****/
var pdpPopupLinks = document.querySelectorAll('.pdp__popup-link');
var pdpPopupOthers = document.querySelectorAll('.pdp__popup');

pdpPopupLinks.forEach(function(link) {
  link.addEventListener('click', function() {
    var pdpPopup = this.nextElementSibling;
    
    pdpPopupOthers.forEach(function(popup) {
      popup.style.display = 'none';
    });
    
    pdpPopup.style.display = 'block';
  });
});

var pdpPopupClose = document.querySelectorAll('.popup__close');

pdpPopupClose.forEach(function(link) {
  link.addEventListener('click', function() {
    var pdpPopup = this.parentElement;
    pdpPopup.style.display = 'none';
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab__title-main li');
  const tabContents = document.querySelectorAll('.tab__content .tabContent');

  function showTab(tabIndex) {
    tabs.forEach(function(tab) {
      tab.classList.remove('active');
    });
    tabContents.forEach(function(content) {
      content.classList.add('hide');
    });

    tabs[tabIndex].classList.add('active');
    tabContents[tabIndex].classList.remove('hide');
  }

  tabs.forEach(function(tab, index) {
    tab.addEventListener('click', function() {
      showTab(index);
      reinitAllGrids();
    });
  });

  var textarea = document.getElementById("Message");
  if(textarea)
    textarea.addEventListener("input", function () {
      this.value = removeEmojis(this.value);
    });

  function removeEmojis(text) {
    var emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{2B50}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
    return text.replace(emojiRegex, "");
  }

  const sectionStepFourElements = document.querySelectorAll(".section-step-four");
  
  sectionStepFourElements.forEach(sectionStepFour => {
    const addButtons = sectionStepFour.querySelectorAll(".add-upcell.button");
    const quantityInputs = sectionStepFour.querySelectorAll(".added-message");
  
    quantityInputs.forEach(input => {
      input.style.display = "none";
    });
  
    addButtons.forEach((addButton, index) => {
      addButton.addEventListener("click", function(event) {
        event.preventDefault();
        addButton.style.display = "none";
        quantityInputs[index].style.display = "flex";
      });
    });
  });

  
});

/***** Product grids same height *****/
customElements.define(
  'grid-alignment-wrapper',
  class gridAlignmentWrapper extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init(){
      let productGrids = this.querySelectorAll('product-grid-height'),
          gridPositions = [],
          positionGrids = [];
      if(productGrids.length == 0) return;
      
      productGrids.forEach(function(grid) {
        if(gridPositions.indexOf(grid.offsetTop) == -1) gridPositions.push(grid.offsetTop);
      });
      
      gridPositions.forEach(function (position) {
        let grids = Array.from(productGrids).filter(function (grid) {
          return (grid.offsetTop == position)
        });
        positionGrids.push(grids);
      });
  
      positionGrids.forEach((grids,index) => {
        let heights = []
        grids.forEach(function (grid) {
          let tmp = [];
          grid.querySelectorAll('.js-height').forEach(function(element) {
            element.style.removeProperty('min-height');
            tmp.push(element.offsetHeight);
          });
          heights.push(tmp);
        });
        if(heights.length > 0){
          let totalSelector = Math.max(...heights.map(ele => {
            return ele.length;
          }));
          grids.forEach(function (grid) {
            for (let index = 0; index < totalSelector; index++) {
              let elementHeights = Math.max(...heights.map(ele => {
                return ele[index];
              }));
              grid.querySelectorAll('.js-height')[index].style.minHeight = `${elementHeights}px`;
            }
          });
        }
      });
    }
  });

function reinitAllGrids(params) {
  document.querySelectorAll('grid-alignment-wrapper').forEach(ele => {
    ele.init();
  });
}
window.onresize = () => {
  reinitAllGrids();
}
window.onload = () => {
  reinitAllGrids();
}

var mobileFacetClose = document.querySelectorAll('.mobile__facet-close');
var mobileFacet = document.querySelectorAll('.mobile-facets__disclosure');

mobileFacetClose.forEach(function(element) {
  element.addEventListener('click', function() {
    mobileFacet.forEach(function(facet) {
      facet.removeAttribute("open");
    });
  });
});

/***** Newsletter Popup *****/
var modal = document.querySelector(".custom__popup");
var trigger = document.querySelector(".footer__Newsletter");
var closeButton = document.querySelector(".close-button");

function toggleModal() {
  modal.classList.toggle("show-modal");
}

function windowOnClick(event) {
  if (event.target === modal) {
    toggleModal();
  }
}

if(trigger)trigger.addEventListener("click", toggleModal);
if(closeButton)closeButton.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);


// setInterval(function(){
// document.querySelector('.klaviyo-form [type="button"]').addEventListener('click',function(ele){
//     ele.preventDefault();
// let form = document.querySelector(".community__newsletter--form form"),
//     input = document.querySelector('.klaviyo-form [type="email"]');
// console.log(input.checkValidity())
//     if(input.checkValidity() != false){
//         form.submit();
//     }
// })
// },1000)

// const checkShippingProtection = setInterval(checkProtection, 1000);
// function checkProtection() {
// const corsoSpElement = document.querySelector('#corso-sp');
//   if (corsoSpElement) {
//     clearInterval(checkShippingProtection);
//       const checkbox = document.getElementById('cn');
//       checkbox.addEventListener('click', function() {
//       if (checkbox.checked) {
//       setTimeout(function(){
//           location.reload();
//         },1500)
//       } else {
//       setTimeout(function(){
//           location.reload();
//         },1500)
//       }
//      });
//    }
// }

function checkAndClearCartIfExpired() {
  var cartTimestamp = getCookie('cartTimestamp');

  if (cartTimestamp) {
    var currentTimestamp = new Date().getTime();
    var twoDaysInMilliseconds = 2 * 24 * 60 * 60 * 1000;

    if (currentTimestamp - cartTimestamp >= twoDaysInMilliseconds) {
      clearCartViaAjax()
    }
  }
}
function clearCartViaAjax() {
  // Define the AJAX request
  var xhr = new XMLHttpRequest();
  
  // Shopify cart API URL for clearing the cart
  var clearCartUrl = '/cart/clear.js';
  
  xhr.open('POST', clearCartUrl, true);
  
  // Set the content type for the request
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        // Cart cleared successfully
      } else {
        // Handle errors if the cart cannot be cleared
        console.error('Error clearing cart:', xhr.statusText);
      }
    }
  };

  // Send the AJAX request
  xhr.send();
}

checkAndClearCartIfExpired();

function minHeight(parentElement, childElement) {
    let productGrids = document.querySelectorAll(parentElement),
        gridPositions = [],
        positionGrids = [];
    if(productGrids.length == 0) return;
    
    productGrids.forEach(function(grid) {
      if(gridPositions.indexOf(grid.offsetTop) == -1) gridPositions.push(grid.offsetTop);
    });
    
    gridPositions.forEach(function (position) {
      let grids = Array.from(productGrids).filter(function (grid) {
        return (grid.offsetTop == position)
      });
      positionGrids.push(grids);
    });

    positionGrids.forEach((grids,index) => {
      let heights = []
      grids.forEach(function (grid) {
        let tmp = [];
        grid.querySelectorAll(childElement).forEach(function(element) {
          element.style.removeProperty('min-height');
          tmp.push(element.offsetHeight);
        });
        heights.push(tmp);
      });
      if(heights.length > 0){
        let totalSelector = Math.max(...heights.map(ele => {
          return ele.length;
        }));
        grids.forEach(function (grid) {
          for (let index = 0; index < totalSelector; index++) {
            let elementHeights = Math.max(...heights.map(ele => {
              return ele[index];
            }));
            grid.querySelectorAll(childElement)[index].style.minHeight = `${elementHeights}px`;
          }
        });
      }
    });  
  }

minHeight('.upcell-product-item', '.item-title');

// custom cart update with specific conditions js start
function isObjectNotEmpty(obj) {
  return Object.keys(obj).length > 0;
}
  
function cartHtml(openDrawer){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-drawer');
    const source = html.getElementById(cartid);			  
    if (source && destination) destination.innerHTML = source.innerHTML;	
  });

  fetch(window.Shopify.routes.root +'?section_id=main-cart-items')
  .then((response) => response.text())
  .then((responseText) => {			  
    const cartid = 'main-cart-items';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart__items');
    const source = html.getElementById(cartid);			  
    if (source && destination) destination.innerHTML = source.innerHTML;	
  });
  if(openDrawer){
    document.querySelector('cart-drawer').open();
  }
}
  
function removeProductFromCart(removeProductIdsObj, openDrawer) {
  const data = {
    updates: {
      ...removeProductIdsObj
    }
  };
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(cartData => {
    cartHtml(openDrawer);
  })
  .catch(error => {
    console.error('Error removing product from cart:', error);
  });
  
}

function removeProductFromCartByKey(removeProductIdsObj, openDrawer) {
  const data = {
    updates: {
      ...removeProductIdsObj
    }
  };
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(cartData => {
    cartHtml(openDrawer);
  })
  .catch(error => {
    console.error('Error removing product from cart:', error);
  });
  
}

function getIndex(arrayOfObjects, uniqIdToSearch){
  return arrayOfObjects.findIndex(function(obj) {
    return obj.properties && obj.properties._uniq_id == uniqIdToSearch;
  });
}

function singleProductCheck(cartItems, id, subscription, keepUpsell, openDrawer, appendErrorText, clickedProductId, recentlyClidecBtn, reliefItemId){
  let productId = id;
  let productObjectIndex = null;
  let giftObjIndex = null;
  let defaultObjExist = false;
  let productObject = null;
  if(subscription){
    productObject = cartItems.find(function(obj) {
      return obj.product_id == productId && obj?.selling_plan_allocation?.selling_plan?.id;
    });
  }else{
     productObject = cartItems.find(function(obj) {
      return obj.product_id == productId;
    });
  }

  if(productObject){
    let mainUniqId = '';
    
    mainUniqId = productObject.properties._main_product;
    
    productObjectIndex = cartItems.findIndex(function(obj) {
      return obj.product_id == productId;
    });
    
    giftObjIndex = getIndex(cartItems, mainUniqId)

    let defaultObjId = '7297792737316';
    if(cartItems[0].product_id == defaultObjId){
      defaultObjExist = true;
    }
    
    let removeProductIdsObj = {};
    let removeProductIdsObjKey = {};
    let uniqMainIdsArr= [];
    let upsellProductIds = [];

    cartItems.forEach(function(item) {
      if(item.product_id == productId){
        uniqMainIdsArr.push(item?.properties['_main_product']);
      }
      if(keepUpsell && item?.properties['_upsell']){
        upsellProductIds.push(item.product_id)
      }
    });

    cartItems.forEach(function(item, index) {
      if(keepUpsell){
        if (productObjectIndex == index || giftObjIndex == index || upsellProductIds?.includes(item.product_id)) {
        }else{
          if(defaultObjExist){
            if(index != 0){
              if(item.product_id != productId && !uniqMainIdsArr?.includes(item?.properties?.['_uniq_id']) && !upsellProductIds?.includes(item.product_id)){
                removeProductIdsObjKey[item.key] = 0;
              }
            }
          }else{
            if(item.product_id != productId && !uniqMainIdsArr?.includes(item?.properties?.['_uniq_id']) && !upsellProductIds?.includes(item.product_id)){
              removeProductIdsObjKey[item.key] = 0;
            }
          }
        }
      }else{
        if (productObjectIndex == index || giftObjIndex == index) {
        }else{
          if(defaultObjExist){
            if(index != 0){
              if(item.product_id != productId && !uniqMainIdsArr?.includes(item?.properties?.['_uniq_id'])){
                // removeProductIdsObj[item.variant_id] = 0;
                removeProductIdsObjKey[item.key] = 0;
              }
            }
          }else{
            if(item.product_id != productId && !uniqMainIdsArr?.includes(item?.properties?.['_uniq_id'])){
              // removeProductIdsObj[item.variant_id] = 0;
              removeProductIdsObjKey[item.key] = 0;
            }
          }
        }
      }
    });

    // if(reliefItemId){
    //   if (removeProductIdsObj.hasOwnProperty(reliefItemId)) {
    //     delete removeProductIdsObj[reliefItemId];
    //   }
    // }
    let foundItem = cartItems.find(item => item.product_id == clickedProductId);

    let openDrawerUpdate = openDrawer;

    if(isObjectNotEmpty(removeProductIdsObjKey)){
      if(Object.keys(removeProductIdsObjKey)?.length > 1){
        if (removeProductIdsObjKey.hasOwnProperty(foundItem?.id)) {
          if(appendErrorText){
            let errorMs = `Sorry! This item cannot be added to your cart because ${productObject.product_title} is already in there, please clear your cart to continue.`
            appendErrorText(errorMs);
            openDrawerUpdate = false;
          }
        }
      }
      removeProductFromCartByKey(removeProductIdsObjKey, openDrawerUpdate);
      removeDisableFromSubmit(recentlyClidecBtn);
    }else{
      removeDisableFromSubmit(recentlyClidecBtn);
      if(openDrawer){
        document.querySelector('cart-drawer').open();
      }
    }
    
    // if(isObjectNotEmpty(removeProductIdsObj)){
    //   if(Object.keys(removeProductIdsObj)?.length > 1){
    //     if (removeProductIdsObj.hasOwnProperty(foundItem?.id)) {
    //       if(appendErrorText){
    //         let errorMs = `Sorry! This item cannot be added to your cart because ${productObject.product_title} is already in there, please clear your cart to continue.`
    //         appendErrorText(errorMs);
    //         openDrawerUpdate = false;
    //       }
    //     }
    //   }
    //   removeProductFromCart(removeProductIdsObj, openDrawerUpdate);
    //   removeDisableFromSubmit(recentlyClidecBtn);
    // }else{
    //   removeDisableFromSubmit(recentlyClidecBtn);
    //   if(openDrawer){
    //     document.querySelector('cart-drawer').open();
    //   }
    // }
  }
}

function multiProductCheck(cartItems, ids, removableProductsIdsArr, keepUpsell, openDrawer, appendErrorText, clickedProductId, recentlyClidecBtn){
  let productIds = ids;
  let defaultObjExist = false;
  let uniqMainIdsArr = [];
  let upsellProductIds = [];
  
  cartItems.forEach(function(item) {
    if(productIds?.includes(item.product_id)){
      uniqMainIdsArr.push(item?.properties['_main_product']);
    }
    if(keepUpsell && item?.properties['_upsell']){
      upsellProductIds.push(item.product_id)
    }
  });

  let matchedItems = cartItems?.filter(item => productIds?.includes(item.product_id));

  if(uniqMainIdsArr?.length > 0){
    let removableProductsIds = removableProductsIdsArr;
    let removable = false;
    let removeProductIdsObj = {};
    let defaultObjId = '7297792737316';
    let freeGiftRemovableMainIds = [];
    
    if(cartItems[0].product_id == defaultObjId){
      defaultObjExist = true;
    }
    cartItems.forEach(function(item) {
      if(productIds?.includes(item.product_id)){
        uniqMainIdsArr.push(item?.properties['_main_product']);
        removable = true;
      }
      if(removableProductsIds?.includes(item.product_id)){
        let mainId = item?.properties['_main_product'];
        if(mainId){
          freeGiftRemovableMainIds.push(mainId);
        }
      }
    });

    if(removable){
      cartItems.forEach(function(item, index) {

        if(keepUpsell){
          if((removableProductsIds?.includes(item.product_id) || freeGiftRemovableMainIds?.includes(item?.properties['_uniq_id'])) && !upsellProductIds?.includes(item.product_id)){
            if(defaultObjExist){
              if(index != 0){
                removeProductIdsObj[item.variant_id] = 0
              }
            }else{
                removeProductIdsObj[item.variant_id] = 0
            }
          }
        }else{
          if(removableProductsIds?.includes(item.product_id) || freeGiftRemovableMainIds?.includes(item?.properties['_uniq_id'])){
            if(defaultObjExist){
              if(index != 0){
                removeProductIdsObj[item.variant_id] = 0
              }
            }else{
                removeProductIdsObj[item.variant_id] = 0
            }
          }
        }
      });

      let foundItem = cartItems.find(item => item.product_id == clickedProductId);
      let openDrawerUpdate = openDrawer;
      if(isObjectNotEmpty(removeProductIdsObj)){
        if (matchedItems) {
          let productTitle = matchedItems?.[0]?.product_title;
          let errorMs = `Sorry! This item cannot be added to your cart because ${productTitle} is already in there, please clear your cart to continue.`;
          if(Object.keys(removeProductIdsObj)?.length > 1){
            if (removeProductIdsObj.hasOwnProperty(foundItem.id)) {
              if(appendErrorText){
                appendErrorText(errorMs);
                openDrawerUpdate = false;
              }
            }
          }
        }
        removeProductFromCart(removeProductIdsObj, openDrawerUpdate);
        removeDisableFromSubmit(recentlyClidecBtn);
      }else{
        removeDisableFromSubmit(recentlyClidecBtn);
        if(openDrawer){
          document.querySelector('cart-drawer').open();
        }
      }
    }
  }
}

function removeDisableFromSubmit(recentlyClidecBtn) {
  if(recentlyClidecBtn){
    recentlyClidecBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
    recentlyClidecBtn.querySelector('span').classList.remove('hidden-text');
    recentlyClidecBtn.disabled = false;
  }
}

function getCartUpdateCheckout() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartItems = cart.items || [];

      const cartItemsExceptShipping = cartItems.filter(obj => obj.product_id !== 7297792737316);
      const objectsWithKey = cartItems.filter(obj => obj?.properties?.['_upsell']);

      const cartDrawer = document.querySelector('#cart-drawer');
      const checkoutButton = cartDrawer ? cartDrawer.querySelector('.checkout--button') : null;
      const cartCheckoutButton = document.querySelector(".cart__checkout-button");

      if (cartItemsExceptShipping.length === objectsWithKey.length) {
        if (checkoutButton) {
          checkoutButton.setAttribute('href', 'javascript:void(0)');
          checkoutButton.style.opacity = '0.5';
        }
        if (cartCheckoutButton) {
          cartCheckoutButton.setAttribute('href', 'javascript:void(0)');
          cartCheckoutButton.style.opacity = '0.5';
        }
      } else {
        if (checkoutButton) {
          checkoutButton.setAttribute('href', '/checkout');
          checkoutButton.style.opacity = '1';
        }
        if (cartCheckoutButton) {
          cartCheckoutButton.setAttribute('href', '/checkout');
          cartCheckoutButton.style.opacity = '1';
        }
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}



function getCart(openDrawer, recentlyClidecBtn, clickedProductId) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let removeProductIds = []
      let cartItems = cart.items;
      if(cartItems?.length > 0){
        const cartItemsExceptShipping = cartItems?.filter(obj => obj.product_id !== 7297792737316) || [];
        const objectsWithKey = cartItems?.filter(obj => obj?.properties?.['_upsell']) || [];
        const cartDrawer = document.querySelector('#cart-drawer');
        const checkoutButton = cartDrawer?.querySelector('.checkout--button');
        const cartCheckoutButton = document.querySelector(".cart__checkout-button");
        
        if (cartItemsExceptShipping.length === objectsWithKey.length) {
            if (checkoutButton) {
                checkoutButton.setAttribute('href', 'javascript:void(0)');
                checkoutButton.style.opacity = '0.5';
            }
            if (cartCheckoutButton) {
                cartCheckoutButton.setAttribute('href', 'javascript:void(0)');
                cartCheckoutButton.style.opacity = '0.5';
            }
        } else {
            if (checkoutButton) {
                checkoutButton.setAttribute('href', '/checkout');
                checkoutButton.style.opacity = '1';
            }
            if (cartCheckoutButton) {
                cartCheckoutButton.setAttribute('href', '/checkout');
                cartCheckoutButton.style.opacity = '1';
            }
        }

        
        let theSendProductId = 4166952812580;
        let theSendProductIdExist = cartItems.find(function(obj) {
          return obj.product_id == theSendProductId && obj?.selling_plan_allocation?.selling_plan?.id;
        });

        let theFreshSetProductId = 7186335301668;
        let theFreshSetProductIdExist = cartItems.find(function(obj) {
          return obj.product_id == theFreshSetProductId;
        });

        let multipleFreshSetProductIds = [7186335891492, 7186335957028, 7186335367204]
        let removableProductsIdsWhenFreshSet = [4166952812580, 7264368230436, 7557273485348, 7264368328740,7376155934756, 7368469217316, 7380174307364, 7380455096356, 7266917974052, 7266916302884, 7492173856804, 7481613254692, 7474278858788, 7307428495396, 14633373106543, 14698148626799, 14697816949103, 14697819898223, 14697820717423, 14624563298671, 7691347296292, 7654095683620, 7654008029220, 7368468889636];

        var multipleFreshSetProductIdExist = multipleFreshSetProductIds.some(id => {
          return cartItems.some(item => item.product_id === id);
        });

        let theValentineDaySendProductId = [7380174307364]
        let removableProductsIdsWhentheValentineDaySendProductId = [7186335301668, 7186335891492,7186335957028, 7186335367204, 4166952812580, 7376155934756, 7264368328740, 7368469217316, 7264368230436, 7557273485348, 7380455096356];

        let theValentineDaySendProductIdExist = theValentineDaySendProductId.some(id => {
          return cartItems.some(item => item.product_id === id);
        });

        let theValentineDayRosesProductId = [7380455096356]
        let removableProductsIdsWhentheValentineDayRosesProductId = [7186335301668, 7186335891492,7186335957028, 7186335367204, 4166952812580, 7376155934756, 7264368328740, 7368469217316, 7264368230436, 7557273485348, 7380174307364];

        let theValentineDayRosesProductIdExist = theValentineDayRosesProductId.some(id => {
          return cartItems.some(item => item.product_id === id);
        });

        let theSendProductIdNotSub = [4166952812580]
        let removableProductsIdsWhentheSendProductIdNotSub = [7380174307364, 7380455096356, 7186335301668, 7186335891492, 7186335957028, 7186335367204];

        let theSendProductIdNotSubExist = theSendProductIdNotSub.some(id => {
          return cartItems.some(item => item.product_id === id);
        });

        let fsFavoritesProductId = [7376155934756, 7264368328740, 7368469217316, 7264368230436, 7557273485348, 14633373106543, 14698148626799, 14697816949103, 14697819898223, 14697820717423, 14624563298671, 7691347296292, 7654095683620, 7654008029220, 7368468889636];
        
        let removableProductsIdsWhenfsFavoritesProductId = [7380174307364, 7380455096356,7186335301668, 7186335891492, 7186335957028, 7186335367204];

        let fsFavoritesProductIdExist = fsFavoritesProductId.some(id => {
          return cartItems.some(item => item.product_id === id);
        });
        
        function appendErrorText (errorMsg) {
          if(recentlyClidecBtn){
            removeDisableFromSubmit(recentlyClidecBtn)
            const newPTag = document.createElement('p');
            const divContainer = document.createElement('div');
            divContainer.classList.add('error-msg');
            divContainer.style.color = "red";
            if(errorMsg){
              newPTag.textContent = errorMsg;
            }else{
              newPTag.textContent = 'Sorry, Unable to add product in cart. Please try after clearing your cart again.';
            }
            divContainer.appendChild(newPTag);
            if (window.location.href.includes('/products')) {
              recentlyClidecBtn.closest('.product-form__buttons').insertAdjacentElement('afterend', divContainer);
            } else {
              recentlyClidecBtn.insertAdjacentElement('afterend', divContainer);
            }
            recentlyClidecBtn.classList.add("recentlyClikedBtn");

            setTimeout(function () {
              let elementsToRemove = document.querySelectorAll('.error-msg');
              if (elementsToRemove) {
                elementsToRemove.forEach(element => {
                  element.remove();
                });
              }
              let elementsToRemoveClass = document.querySelectorAll('.recentlyClikedBtn');
              if (elementsToRemove) {
                elementsToRemove.forEach(element => {
                  element.classList.remove('recentlyClikedBtn');
                });
              }
            }, 5000)
          }
        }
        
        if(theSendProductIdExist){
          let reliefItemId = 40923582103588;
          singleProductCheck(cartItems, theSendProductId, true, true, openDrawer, appendErrorText, clickedProductId, recentlyClidecBtn, reliefItemId);
        }else if(theFreshSetProductIdExist){
          singleProductCheck(cartItems, theFreshSetProductId, false, true, openDrawer, appendErrorText, clickedProductId, recentlyClidecBtn);
        }else if(multipleFreshSetProductIdExist){
          multiProductCheck(cartItems, multipleFreshSetProductIds, removableProductsIdsWhenFreshSet, true, openDrawer, appendErrorText, clickedProductId, recentlyClidecBtn);
        }else if(theValentineDaySendProductIdExist){
          multiProductCheck(cartItems, theValentineDaySendProductId, removableProductsIdsWhentheValentineDaySendProductId, true, openDrawer, appendErrorText, clickedProductId, recentlyClidecBtn);
        }else if(theValentineDayRosesProductIdExist){
          multiProductCheck(cartItems, theValentineDayRosesProductId, removableProductsIdsWhentheValentineDayRosesProductId, false, openDrawer, appendErrorText, clickedProductId, recentlyClidecBtn);
        }else if(theSendProductIdNotSubExist){
          multiProductCheck(cartItems, theSendProductIdNotSub, removableProductsIdsWhentheSendProductIdNotSub, true, openDrawer, appendErrorText, clickedProductId, recentlyClidecBtn);
        }else if(fsFavoritesProductIdExist){
          multiProductCheck(cartItems, fsFavoritesProductId, removableProductsIdsWhenfsFavoritesProductId, true, openDrawer, appendErrorText, clickedProductId, recentlyClidecBtn);
        }else{
          if(openDrawer){
            document.querySelector('cart-drawer').open();
            removeDisableFromSubmit(recentlyClidecBtn);
          }
        }
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}


function appendErrorTextUpdate (errorMsg, recentlyClickedcBtn) {
  if(recentlyClickedcBtn){
    const newPTag = document.createElement('p');
    const divContainer = document.createElement('div');
    divContainer.classList.add('error-msg');
    divContainer.style.color = "red";
    if(errorMsg){
      newPTag.textContent = errorMsg;
    }else{
      newPTag.textContent = 'Sorry, Unable to add product in cart. Please try after clearing your cart again.';
    }
    divContainer.appendChild(newPTag);
    if (window.location.href.includes('/products')) {
      recentlyClickedcBtn.closest('.product-form__buttons').insertAdjacentElement('afterend', divContainer);
    } else {
      recentlyClickedcBtn.insertAdjacentElement('afterend', divContainer);
    }
    recentlyClickedcBtn.classList.add("recentlyClikedBtn");

    setTimeout(function () {
      let elementsToRemove = document.querySelectorAll('.error-msg');
      if (elementsToRemove) {
        elementsToRemove.forEach(element => {
          element.remove();
        });
      }
      let elementsToRemoveClass = document.querySelectorAll('.recentlyClikedBtn');
      if (elementsToRemove) {
        elementsToRemove.forEach(element => {
          element.classList.remove('recentlyClikedBtn');
        });
      }
    }, 5000)
  }
}

function getCartUpdate(dataProductId) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let removeProductIds = []
      let cartItems = cart.items;
      let productCardModelDataProductId = document.querySelector(`product-card-model[data-product-id='${dataProductId}']`);
      if(cartItems?.length > 0){
        let recentlyClickedcBtn = document.querySelector('button[type="submit"][data-product-id="'+dataProductId+'"]');
        let theSendProductId = 4166952812580;
        let theSendProductIdExist = cartItems.find(function(obj) {
          return obj.product_id == theSendProductId && obj?.selling_plan_allocation?.selling_plan?.id;
        });
        
        let theFreshSetProductId = 7186335301668;
        let theFreshSetProductIdExist = cartItems.find(function(obj) {
          return obj.product_id == theFreshSetProductId;
        });

        let multipleFreshSetProductIds = [7186335891492, 7186335957028, 7186335367204]
        let removableProductsIdsWhenFreshSet = [4166952812580, 7264368230436, 7557273485348, 7264368328740,7376155934756, 7368469217316, 7380174307364, 7380455096356, 7266917974052, 7266916302884, 7492173856804, 7481613254692, 7474278858788, 7307428495396, 14633373106543, 14698148626799, 14697816949103, 14697819898223, 14697820717423, 14624563298671, 7691347296292, 7654095683620, 7654008029220, 7368468889636];
        var multipleFreshSetProductIdExist = multipleFreshSetProductIds.some(id => {
          return cartItems.some(item => item.product_id === id);
        });
        
        let theValentineDaySendProductId = 7380174307364;
        let removableProductsIdsWhentheValentineDaySendProductId = [7186335301668, 7186335891492,7186335957028, 7186335367204, 4166952812580, 7376155934756, 7264368328740, 7368469217316, 7264368230436, 7557273485348, 7380455096356];
        let theValentineDaySendProductIdExist = cartItems.find(function(obj) {
          return obj.product_id == theValentineDaySendProductId;
        });
        
        let theValentineDayRosesProductId = 7380455096356;
        let removableProductsIdsWhentheValentineDayRosesProductId = [7186335301668, 7186335891492,7186335957028, 7186335367204, 4166952812580, 7376155934756, 7264368328740, 7368469217316, 7264368230436, 7557273485348, 7380174307364];
        let theValentineDayRosesProductIdExist = cartItems.find(function(obj) {
          return obj.product_id == theValentineDayRosesProductId;
        });
        
        let theSendProductIdNotSub = 4166952812580;
        let removableProductsIdsWhentheSendProductIdNotSub = [7380174307364, 7380455096356, 7186335301668, 7186335891492, 7186335957028, 7186335367204];
        let theSendProductIdNotSubExist = cartItems.find(function(obj) {
          return obj.product_id == theSendProductIdNotSub;
        });
        
        let fsFavoritesProductId = [7376155934756, 7264368328740, 7368469217316, 7264368230436, 7557273485348, 14633373106543, 14698148626799, 14697816949103, 14697819898223, 14697820717423, 14624563298671, 7691347296292, 7654095683620, 7654008029220, 7368468889636];
        let removableProductsIdsWhenfsFavoritesProductId = [7380174307364, 7380455096356,7186335301668, 7186335891492, 7186335957028, 7186335367204];
        var fsFavoritesProductIdExist = fsFavoritesProductId.some(id => {
          return cartItems.some(item => item.product_id === id);
        });

        if(theSendProductIdExist){
          if(theSendProductId == dataProductId || dataProductId == 7380174307364){
            if(productCardModelDataProductId) productCardModelDataProductId.style.display = 'block';
          }else{
            if(recentlyClickedcBtn){
              let errorMsg = `Sorry! This item cannot be added to your cart because ${theSendProductIdExist.title} is already in there, please clear your cart to continue.`;
              appendErrorTextUpdate(errorMsg, recentlyClickedcBtn)
            }
          }
        }else if(theFreshSetProductIdExist){
          if(theFreshSetProductId == dataProductId){
            if(productCardModelDataProductId) productCardModelDataProductId.style.display = 'block';
          }else{
            if(recentlyClickedcBtn){
              let errorMsg = `Sorry! This item cannot be added to your cart because ${theFreshSetProductIdExist.title} is already in there, please clear your cart to continue.`;
              appendErrorTextUpdate(errorMsg, recentlyClickedcBtn)
            }
          }
        }else if(multipleFreshSetProductIdExist){
          if(removableProductsIdsWhenFreshSet.includes(Number(dataProductId))){
            var multipleFreshSetProducts = cartItems.filter(item => {
              return multipleFreshSetProductIds.includes(item.product_id);
            });
            if(recentlyClickedcBtn){
              let errorMsg = `Sorry! This item cannot be added to your cart because ${multipleFreshSetProducts?.[0]?.title} is already in there, please clear your cart to continue.`;
              appendErrorTextUpdate(errorMsg, recentlyClickedcBtn)
            }
          }else{
            if(productCardModelDataProductId) productCardModelDataProductId.style.display = 'block';
          }
        }else if(theValentineDaySendProductIdExist){
          if(removableProductsIdsWhentheValentineDaySendProductId.includes(Number(dataProductId))){
            if(recentlyClickedcBtn){
              let errorMsg = `Sorry! This item cannot be added to your cart because ${theValentineDaySendProductIdExist?.title} is already in there, please clear your cart to continue.`;
              appendErrorTextUpdate(errorMsg, recentlyClickedcBtn)
            }
          }else{
            if(productCardModelDataProductId) productCardModelDataProductId.style.display = 'block';
          }
        }else if(theValentineDayRosesProductIdExist){
          if(removableProductsIdsWhentheValentineDayRosesProductId.includes(Number(dataProductId))){
            if(recentlyClickedcBtn){
              let errorMsg = `Sorry! This item cannot be added to your cart because ${theValentineDayRosesProductIdExist?.title} is already in there, please clear your cart to continue.`;
              appendErrorTextUpdate(errorMsg, recentlyClickedcBtn)
            }
          }else{
            if(productCardModelDataProductId) productCardModelDataProductId.style.display = 'block';
          }
        }else if(theSendProductIdNotSubExist){
          if(removableProductsIdsWhentheSendProductIdNotSub.includes(Number(dataProductId))){
            if(recentlyClickedcBtn){
              let errorMsg = `Sorry! This item cannot be added to your cart because ${theSendProductIdNotSubExist?.title} is already in there, please clear your cart to continue.`;
              appendErrorTextUpdate(errorMsg, recentlyClickedcBtn)
            }
          }else{
            if(productCardModelDataProductId) productCardModelDataProductId.style.display = 'block';
          }
        }else if(fsFavoritesProductIdExist){
          if(removableProductsIdsWhenfsFavoritesProductId.includes(Number(dataProductId))){
            var multiplefsFavoritesProducts = cartItems.filter(item => {
              return fsFavoritesProductId.includes(item.product_id);
            });
            if(recentlyClickedcBtn){
              let errorMsg = `Sorry! This item cannot be added to your cart because ${multiplefsFavoritesProducts?.[0]?.title} is already in there, please clear your cart to continue.`;
              appendErrorTextUpdate(errorMsg, recentlyClickedcBtn)
            }
          }else{
            if(productCardModelDataProductId) productCardModelDataProductId.style.display = 'block';
          }
        }else{
          if(productCardModelDataProductId) productCardModelDataProductId.style.display = 'block';
        }
      }else{
        if(productCardModelDataProductId) productCardModelDataProductId.style.display = 'block';
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

document.addEventListener('DOMContentLoaded', function() {
  getCart(false);
  const targetNode = document.querySelector('.section-step-four');
  if (targetNode) {
    const config = { attributes: true, attributeFilter: ['class'] };
    const callback = function(mutationsList, observer) {
        for(const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (!targetNode.classList.contains('hidden')) {
                  var popupSwiperSlider = new Swiper('.upcell-items-slider', {
                    slidesPerView: 3,
                    spaceBetween: 25,
                    loop: false,
                    pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                      type: "fraction",
                    }, 
                    navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                    },
                    scrollbar: {
                      el: '.swiper-scrollbar',
                      draggable: true
                    }
                  });
                }
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
});
// custom cart update with specific conditions js end

/***** community-grid Section Start *****/
let currentlyOpen = null;
let currentToggle = null;

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('toggle') || event.target.closest('.toggle')) {
    event.preventDefault();

    const toggleElement = event.target.classList.contains('toggle') ? event.target : event.target.closest('.toggle');
    const target = toggleElement.getAttribute('data-target');
    const targetElement = document.getElementById(target);

    if (targetElement) {
      if (currentlyOpen && currentlyOpen !== targetElement) {
        currentlyOpen.classList.add('hide');
        currentToggle.classList.remove('active');
      }
      
      const isHidden = targetElement.classList.toggle('hide');

      if (isHidden) {
        targetElement.classList.remove('active');
        toggleElement.classList.remove('active');
        currentlyOpen = null;
        currentToggle = null;
        document.body.classList.remove('community__popup--open');
      } else {
        targetElement.classList.add('active');
        toggleElement.classList.add('active');
        currentlyOpen = targetElement;
        currentToggle = toggleElement;
        document.body.classList.add('community__popup--open');
      }
    } else {
      console.warn(`Element with ID "${target}" not found.`);
    }
  } else if (currentlyOpen && !event.target.closest('.popup')) {
    currentlyOpen.classList.add('hide');
    currentlyOpen.classList.remove('active');
    currentToggle.classList.remove('active');
    currentlyOpen = null;
    currentToggle = null;
    document.body.classList.remove('community__popup--open');
  }
});

document.addEventListener('click', function(event) {
  if (event.target.closest('.popup')) {
    event.stopPropagation();
  }
});

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('close')) {
    event.preventDefault();

    const target = event.target.getAttribute('data-target');
    const targetElement = document.getElementById(target);

    if (targetElement) {
      targetElement.classList.add('hide');
      targetElement.classList.remove('active');

      const toggleElement = document.querySelector(`.toggle[data-target="${target}"]`);
      if (toggleElement) {
        toggleElement.classList.remove('active');
      }

      document.body.classList.remove('community__popup--open');

      currentlyOpen = null;
      currentToggle = null;
    }
  }
});
/***** community-grid Section End *****/


// Header height js

  // Gift product slider

window.selectionNum = 3;
window.candyVariantIds = [];
function candyInputDeselectListener() {
  let customCandyInputs = document.querySelectorAll(".custom__candy--input");
  customCandyInputs.forEach(function (customCandyInput) {
    if(customCandyInput.checked){
      customCandyInput.checked = false;
    }
  });
  window.candyVariantIds = [];
}

document.querySelectorAll(".candy__qty--selector").forEach(function (ele) {
  let previousValue = ele.value;

  ele.addEventListener("focus", function () {
    // Save the current value when focused
    previousValue = ele.value;
  });

  ele.addEventListener("change", function () {
      let selectionNumber = window.selectionNum ?? 0;
      let closestProductContentWrap = ele.closest(".product__content--wrap");
      let childCustomCandyInputs = closestProductContentWrap.querySelectorAll("input[type='checkbox']:checked");
  
      let totalCount = 0;
  
      childCustomCandyInputs.forEach(function (element) {
        let closestProductContent = element.closest(".product__content");
        if (closestProductContent) {
          let candyQtySelector = closestProductContent.querySelector(".candy__qty--selector");
          if (candyQtySelector) {
            totalCount += Number(candyQtySelector.value);
          }
        }
      });
  
      if (totalCount > selectionNumber) {
  
        let errorMsgValidation = document.querySelector(".candies-error-msg-validation");
  
        if(errorMsgValidation){
          errorMsgValidation.textContent = `You can only select up to ${selectionNumber} items.`;
          setTimeout(() => {
            errorMsgValidation.textContent = "";
          }, 5000);
        }
          
        ele.value = previousValue;
      } else {
        // Update previousValue if change is valid
        previousValue = ele.value;
      }
  
      if (window.addCandyOnSubmit) {
        let closestForm = ele.closest("form");
        let productFormSubmit = closestForm.querySelector(".product-form__submit");
        
        if(totalCount == selectionNumber){
          if (productFormSubmit && window.currentVariantAvailable) {
            if (productFormSubmit.hasAttribute('disabled')) {
              productFormSubmit.removeAttribute('disabled');
            }
          }
        }else if(totalCount < selectionNumber){
          if (productFormSubmit) {
            productFormSubmit.setAttribute('disabled', 'disabled');
          }
        }
      }
    
    });
});


function candyInputListener() {
  window.candyVariantIds = [];
  let customCandyInputs = document.querySelectorAll(".custom__candy--input");
  customCandyInputs.forEach(function (customCandyInput) {
    customCandyInput.addEventListener("change", function (event) {

      let selctionLimit = window.selectionNum;
      let closestProductContentWrap = customCandyInput.closest(".product__content--wrap");
      if(closestProductContentWrap){
        let childCustomCandyInputs = closestProductContentWrap.querySelectorAll("input[type='checkbox']:checked");

        let checkedInputsLength = childCustomCandyInputs ? childCustomCandyInputs?.length : 0;
        let totalCount = 0;
        if(window.addCandyOnSubmit){
          
          let childCustomCandyInputsNotSelected = closestProductContentWrap.querySelectorAll("input[type='checkbox']:not(:checked)");
          
          childCustomCandyInputsNotSelected.forEach(function (element) {
            let closestProductContent = element.closest(".product__content");
            if (closestProductContent) {
              let candyQtySelector = closestProductContent.querySelector(".candy__qty--selector");
              if (candyQtySelector) {
                candyQtySelector.value = "1"; // Ensure this matches an actual <option value="1">
                candyQtySelector.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          });

          childCustomCandyInputs.forEach(function (element) {
            let closestProductContent = element.closest(".product__content");
            if(closestProductContent){
              let candyQtySelector = closestProductContent.querySelector(".candy__qty--selector");
              if(candyQtySelector){
                let candyQtySelectorValue = candyQtySelector.value;
                totalCount += Number(candyQtySelectorValue);
              }
            }
          })
          checkedInputsLength = totalCount;
        }
        
        if (window.addCandyOnSubmit) {
          let closestForm = customCandyInput.closest("form");
          let productFormSubmit = closestForm.querySelector(".product-form__submit");
          
          if(checkedInputsLength == selctionLimit){
            if (productFormSubmit && window.currentVariantAvailable) {
              if (productFormSubmit.hasAttribute('disabled')) {
                productFormSubmit.removeAttribute('disabled');
              }
            }
          }else if(checkedInputsLength < selctionLimit){
            if (productFormSubmit) {
              productFormSubmit.setAttribute('disabled', 'disabled');
            }
          }
        }
        
        
        if(checkedInputsLength > selctionLimit){
          customCandyInput.checked = false;
          event.preventDefault();
        }
        if(customCandyInput.checked){
          window.candyVariantIds.push(customCandyInput.value)
        }else{
          window.candyVariantIds?.includes(customCandyInput.value) && window.candyVariantIds?.splice(window.candyVariantIds?.indexOf(customCandyInput.value), 1);
        }

        let customCandyAddBtn = document.querySelector(".custom__candy--add-btn");
        if(window.candyVariantIds?.length > 0 && window.candyVariantIds?.length <= selctionLimit){
          if(customCandyAddBtn) customCandyAddBtn.disabled = false;
        }else{
          if(customCandyAddBtn) customCandyAddBtn.disabled = true;
        }
      }
    })
  });
}

function popupToggleListener() {
  document.querySelectorAll('.learn__more--link').forEach((item)=>{
      item.addEventListener('click', (el)=>{
          var button_value = el.target.getAttribute('data-button-id');
          document.querySelectorAll('.gift__popup--wrap').forEach((p_item)=>{
              var popup_value = p_item.getAttribute('data-id');
              p_item.classList.remove('active');
              if(button_value == popup_value){
                p_item.classList.add('active');
                document.querySelector("body").classList.add('gift_popup_open');
                let inputRadio = p_item.querySelector('input[type="radio"]');
                if(inputRadio){
                  inputRadio.setAttribute('checked', 'checked');
                }
              }
              popupContentATCListener();
          });
          window.customValidation();
      })
  })
  document.querySelectorAll('.popup-content .close').forEach((item)=>{
      item.addEventListener('click', (el)=>{
          document.querySelectorAll('.gift__popup--wrap').forEach((p_item)=>{
            p_item.classList.remove('active');
            document.querySelector("body").classList.remove('gift_popup_open');
          });
          candyInputDeselectListener();
      })
  });

  const giftPopupWraps = document.querySelectorAll('.gift__popup--wrap');
  giftPopupWraps.forEach((popupWrap) => {
    popupWrap.addEventListener('click', function(event) {
      const popupContent = popupWrap.querySelector('.popup-content');
      if (!popupContent.contains(event.target)) {
        popupWrap.classList.remove('active');
        document.querySelector("body").classList.remove('gift_popup_open');
        candyInputDeselectListener();
      }
    });
  });
  
}

window.addEventListener('load', function() {
    const outerHeaderWrapper = document.querySelector('.outer-header-wrapper');

    function getOuterHeight(el) {
        const style = getComputedStyle(el);
        const margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
        return Math.ceil(el.offsetHeight + margin);
    }
  
    const outerHeaderHeight = getOuterHeight(outerHeaderWrapper);

    document.documentElement.style.setProperty('--header-height', `${outerHeaderHeight}px`);
    popupToggleListener();
    candyInputListener();
});

//Gift Popup

function atcGetSectionsToRenderBubble() {
  return [
    {
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }
  ];
}

let upsellArray = [];
window.specificUpsellData = null;
function popupContentATCListener() {
  const popupContents = document.querySelectorAll('.popup-content');

  if(popupContents){
    popupContents.forEach(function (popupContent) {
      let popupContentATC = popupContent.querySelector('.add__button');
      let customCandyAddBtn = popupContent.querySelector('.custom__candy--add-btn');
      
      if(popupContentATC){
        popupContentATC.addEventListener('click', function () {
          let err = null;
          let errorMsgValidation = document.querySelector(".error-msg-validation");
          let lowerCaseVariantTitle = window.currentVariant?.title?.toLowerCase(); // Use toLowerCase unless locale-specific reasons
          if ((!lowerCaseVariantTitle?.includes("mini") && !lowerCaseVariantTitle?.includes("no vase")) && (popupContentATC.getAttribute('data-title')?.toLowerCase()?.includes('candle') || popupContentATC.getAttribute('data-title')?.toLowerCase()?.includes('pasta'))) {
            err = 'Oops! You have too many add-ons in your order, please remove one item to continue.';
            if(errorMsgValidation){
              errorMsgValidation.textContent = err;
              // setTimeout(() => {
              //   errorMsgValidation.textContent = "";
              // }, 7000);
            }
          }else if ((window.candyVariantIds?.length > 1) && (popupContentATC.getAttribute('data-title')?.toLowerCase()?.includes('candle') || popupContentATC.getAttribute('data-title')?.toLowerCase()?.includes('pasta'))) {
            err = 'Oops! Only 1 candy can be added with a candle. Please update your order to continue.';
            if(popupContentATC.getAttribute('data-title')?.toLowerCase()?.includes('pasta')){
              err = 'Oops! Only 1 candy can be added with a The Pasta Night Set. Please update your order to continue.';
            }
            if(errorMsgValidation){
              errorMsgValidation.textContent = err;
              // setTimeout(() => {
              //   errorMsgValidation.textContent = "";
              // }, 7000);
            }
          }else if (lowerCaseVariantTitle?.includes("mini") && popupContentATC.getAttribute('data-title')?.toLowerCase()?.includes('perfume') && window.candyVariantIds?.length > 1) {
            err = 'Oops! You have too many add-ons in your order, please remove one item to continue.';
            if(errorMsgValidation){
              errorMsgValidation.textContent = err;
              // setTimeout(() => {
              //   errorMsgValidation.textContent = "";
              // }, 7000);
            }
          }else if (lowerCaseVariantTitle?.includes("mini") && popupContentATC.getAttribute('data-title')?.toLowerCase()?.includes('hand cream') && window.candyVariantIds?.length > 1) {
            err = 'Oops! You have too many add-ons in your order, please remove one item to continue.';
            if(errorMsgValidation){
              errorMsgValidation.textContent = err;
              // setTimeout(() => {
              //   errorMsgValidation.textContent = "";
              // }, 7000);
            }
          }else if (lowerCaseVariantTitle?.includes("mini") && popupContentATC.getAttribute('data-title')?.toLowerCase()?.includes('signature tote') && window.candyVariantIds?.length > 1) {
            err = 'Oops! You have too many add-ons in your order, please remove one item to continue.';
            if(errorMsgValidation){
              errorMsgValidation.textContent = err;
              // setTimeout(() => {
              //   errorMsgValidation.textContent = "";
              // }, 7000);
            }
          }else{
            let closestForm = popupContentATC.closest('form');
            if(closestForm){
              // popupContentATC.classList.add('loading');
              let varIdInput = closestForm.querySelector("input[name='id']");
              let varId = null;
              if(varIdInput){
                varId = varIdInput.value;
                let variantIdsInputs = document.querySelectorAll('.variantIds');
                if(variantIdsInputs){
                  variantIdsInputs.forEach(function (variantIdsInput) {
                    let variantIdsInputValue = variantIdsInput.value;
                    if(variantIdsInputValue?.includes(varId)){
                      let productInfoWrap = variantIdsInput.closest('.product__info--wrap');
                      if(productInfoWrap){
                        productInfoWrap.classList.add('gift__product--added');
                      }
                    }
                  })
                }
              }
              let idExists = upsellArray?.some(product => product.id === varId);
              if(!idExists){
                let obj = {
                  'id': varId,
                  'quantity': 1
                }
                upsellArray.push(obj)
              }
              window.specificUpsellData = upsellArray;
              // document.querySelectorAll('.gift__popup--wrap').forEach((p_item) => {
              //   p_item.classList.remove('active');
              //   document.querySelector("body").classList.remove('gift_popup_open');
              // });
            }
            if(errorMsgValidation){
              errorMsgValidation.textContent = "";
            }
          }

          document.querySelectorAll('.gift__popup--wrap').forEach((p_item) => {
            p_item.classList.remove('active');
            document.querySelector("body").classList.remove('gift_popup_open');
          });
          
        })
      }
      if(customCandyAddBtn){
        customCandyAddBtn.addEventListener("click", function () {
          let candyVariantIds = window.candyVariantIds;
          let customValidation = window.customValidation();
          let errorMsgValidation = document.querySelector(".error-msg-validation");
          if(customValidation){
            if(errorMsgValidation){
              errorMsgValidation.textContent = customValidation;
              // setTimeout(() => {
              //   errorMsgValidation.textContent = "";
              // }, 7000);
            }
          }else{
            candyVariantIds.forEach(id => {
              let idExists = upsellArray?.some(product => product.id === id);
              if(!idExists){
                let obj = {
                  'id': id,
                  'quantity': 1
                }
                upsellArray.push(obj)
              }
              window.specificUpsellData = upsellArray;
            });
            let productInfoWrap = document.querySelector('.product__info--wrap-candy');
            if(productInfoWrap){
              productInfoWrap.classList.add('gift__product--added');
            }
            if(errorMsgValidation){
              errorMsgValidation.textContent = "";
            }
          }
          document.querySelectorAll('.gift__popup--wrap').forEach((p_item) => {
            p_item.classList.remove('active');
            document.querySelector("body").classList.remove('gift_popup_open');
          });
        });
      }
    })
  }
}


function addToCartListenerUpdate(setLoading, dataArray) {
  let sections = ["cart-drawer","cart-icon-bubble"];
  let formData = {
   'items': dataArray,
    'sections' : sections
  };
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    if(setLoading){
      let productSendfs = document.querySelector('.product__send--fs');
      if(productSendfs){
        let productFormSubmit = productSendfs.querySelector('.product-form__submit');
        if(productFormSubmit){
          productFormSubmit.removeAttribute('disabled');
          productFormSubmit.classList.remove('loading');
          productFormSubmit.querySelector('.cart-text').classList.remove('hidden');
          productFormSubmit.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
      }
    }
    atcGetSectionsToRenderBubble().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    
      elementToReplace.innerHTML =
        getSectionInnerHTML(data?.sections[section?.section], section?.selector);
    }));
    document.querySelector('cart-drawer').open();

  })
  .catch(error => {
    console.error('Error adding product to cart:', error);
    if(setLoading){
      let productSendfs = document.querySelector('.product__send--fs');
      if(productSendfs){
        let productFormSubmit = productSendfs.querySelector('.product-form__submit');
        if(productFormSubmit){
          productFormSubmit.removeAttribute('disabled');
          productFormSubmit.classList.remove('loading');
          productFormSubmit.querySelector('.cart-text').classList.remove('hidden');
          productFormSubmit.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
      }
    }
  });
}

// let productSendfs = document.querySelector('.product__send--fs');
// if(productSendfs){
//   let productFormSubmit = productSendfs.querySelector('.product-form__submit');
//   if(productFormSubmit){
//     productFormSubmit.addEventListener('click', function (event) {
//       event.preventDefault();
//       productFormSubmit.classList.add('loading');
//       productFormSubmit.setAttribute('disabled', 'disabled');
//       productFormSubmit.querySelector('.cart-text').classList.add('hidden');
//       productFormSubmit.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       let closestForm = productFormSubmit.closest('form');
//       if(closestForm){
//         let varIdInput = closestForm.querySelector("input[name='id']");
//         let varId = null;
//         if(varIdInput){
//           varId = varIdInput.value;
//         }
//         const idExists = upsellArray?.some(product => product.id === varId);
//         if(!idExists){
//           let obj = {
//             'id': varId,
//             'quantity': 1
//           }
//           upsellArray.push(obj)
//         }

//         addToCartListenerUpdate(true, upsellArray)
//       }
//     })
//   }
// }

window.updateCartAttribute = function(){
  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(response => { 
    
    let includesCandies = false;
    let candyIncluded = 0;
    for(let item in response.items){
      let currentItem = response.items[item];
      if(currentItem.product_type.toLowerCase().includes("candy")){
        includesCandies = true;
        candyIncluded = candyIncluded + 1
      }
    }

    let notesUpdated = false;
    if(includesCandies && candyIncluded > 1){
      for(let item in response.items){
        let currentItem = response.items[item];
        if(currentItem.product_type.toLowerCase().includes("bouquet")){
          if(currentItem.title.toLowerCase().includes("full") || currentItem.title.toLowerCase().includes("regular")){
            notesUpdated = true;
            window.updateCartAttributesAJAX(window.cartStrings.custom_note);
          }
        }
      }
    }
    if(!notesUpdated){
      window.updateCartAttributesAJAX("");
    }
  });
}

window.updateCartAttributesAJAX = function(message){
 let updates = {
    attributes: {
      'Custom Message': message
    }
  }
  
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updates)  // Send attributes directly
  })
  .then(response => {
    return response.json();
  })
  .then(response => {
    // console.log("response", response);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

try {
  const candyWrap = document.querySelector(
    "#gift__product--wrap .product__info--wrap:has([data-candy-addon])"
  );

  function updateCandyState() {
    try {
      const hasSelection =
        document.querySelectorAll("#candy-selection input:checked").length > 0;

      if (!candyWrap) {
        console.warn("Candy wrapper element not found.");
        return;
      }

      if (hasSelection) {
        candyWrap.classList.add("gift__product--added");
      } else {
        candyWrap.classList.remove("gift__product--added");
      }
    } catch (error) {
      console.error("Error updating candy state:", error);
    }
  }

  // Update when selection changes
  const candyInputs = document.querySelectorAll("#candy-selection input");

  if (candyInputs.length) {
    candyInputs.forEach(input => {
      input.addEventListener("change", updateCandyState);
    });
  } else {
    console.warn("No candy selection inputs found.");
  }

  // Update when Add button is clicked
  const addButton = document.querySelector(
    ".main-product-2026__buybox #candy-selection #candy-selection-content .custom-candy-upsell"
  );

  if (addButton) {
    addButton.addEventListener("click", function () {
      try {
        updateCandyState();
      } catch (error) {
        console.error("Error handling Add button click:", error);
      }
    });
  } else {
    console.warn("Candy Add button not found.");
  }

  // Set initial state
  updateCandyState();

} catch (error) {
  console.error("Candy initialization failed:", error);
}

try {
  const vaseRadios = document.querySelectorAll('#vase__custom--pdp input[type="radio"]');

  if (!vaseRadios.length) {
    console.warn('No vase radio buttons found.');
  } else {
    vaseRadios.forEach(radio => {
      try {
        radio.dataset.wasChecked = radio.checked;

        radio.addEventListener('click', function () {
          const candle = radio.closest('form').querySelector('.addon--the-candle');
          try {
            if (this.dataset.wasChecked === 'true') {
              this.checked = false;
              this.dataset.wasChecked = 'false';

              // Remove candle
              if (candle) {
                candle.classList.remove('hidden');
              }
            } else {
              document.querySelectorAll('#vase__custom--pdp input[type="radio"]').forEach(r => {
                r.dataset.wasChecked = 'false';
              });

              this.checked = true;
              this.dataset.wasChecked = 'true';

              // Add candle
              if (candle) {
                candle.classList.add('hidden');
              }
            }

            this.dispatchEvent(new Event('change', { bubbles: true }));
          } catch (error) {
            console.error('Error handling vase radio click:', error);
          }
        });
      } catch (error) {
        console.error('Error initializing vase radio:', error);
      }
    });
  }
} catch (error) {
  console.error('Error initializing vase radio buttons:', error);
}

// on variant change - hide Vase options and uncheck all the selected vase options
try {
  document.addEventListener('variant:change', function (e) {
    try {
      const variant = e?.detail?.variant;

      if (!variant) {
        console.warn('Variant change event fired without a valid variant.');
        return;
      }

      const vaseContainer = document.querySelector('#vase__custom--pdp');

      if (!vaseContainer) {
        console.warn('#vase__custom--pdp not found.');
        return;
      }

      const addonProducts = vaseContainer.closest('addon-products');

      if (!addonProducts) {
        console.warn('Parent <addon-products> not found.');
        return;
      }

      if (variant.option1 && variant.option1.toLowerCase() === 'mini') {
        addonProducts.classList.add('visually-hidden');

        vaseContainer.querySelectorAll('input:checked').forEach(input => {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      } else {
        addonProducts.classList.remove('visually-hidden');
      }

    } catch (error) {
      console.error('Error handling variant:change event:', error);
    }
  });
} catch (error) {
  console.error('Failed to initialise variant:change listener:', error);
}